import Vue from "vue";

export const TagsState = {
  branches: [],
  totalBranches: 0,
  //
  labels: [],
  totalLabels: 0,
  //
  prospectTags: [],
  totalProspectTags: 0
};

export const TagsGetters = {
  branches: state => {
    return state.branches;
  },
  totalBranches: state => {
    return state.totalBranches;
  },
  //
  labels: state => {
    return state.labels;
  },
  totalLabels: state => {
    return state.totalLabels;
  },
  //
  prospectTags: state => {
    return state.prospectTags;
  },
  totalProspectTags: state => {
    return state.totalProspectTags;
  }
};

export const TagsMutations = {
  setBranch: (state, data) => {
    if (data) {
      const index = state.branches.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.branches];
        arr[index] = data;
        Vue.set(state, "branches", arr);
      }
    }
  },
  setBranches: (state, data) => {
    Vue.set(state, "branches", data.branches);
    Vue.set(state, "totalBranches", data.total_count);
  },
  addBranch: (state, data) => {
    Vue.set(state, "branches", [data, ...state.branches]);
    Vue.set(state, "totalBranches", state.totalBranches + 1);
  },
  removeBranch: (state, data) => {
    const arr = state.branches.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "branches", arr);
    Vue.set(state, "totalBranches", state.totalBranches - 1);
  },
  //
  setLabel: (state, data) => {
    if (data) {
      const index = state.labels.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.labels];
        arr[index] = data;
        Vue.set(state, "labels", arr);
      }
    }
  },
  setLabels: (state, data) => {
    Vue.set(state, "labels", data.labels);
    Vue.set(state, "totalLabels", data.total_count);
  },
  addLabel: (state, data) => {
    Vue.set(state, "labels", [data, ...state.labels]);
    Vue.set(state, "totalLabels", state.totalLabels + 1);
  },
  removeLabel: (state, data) => {
    const arr = state.labels.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "labels", arr);
    Vue.set(state, "totalLabels", state.totalLabels - 1);
  },
  //
  setProspectTag: (state, data) => {
    if (data) {
      const index = state.prospectTags.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.prospectTags];
        arr[index] = data;
        Vue.set(state, "prospectTags", arr);
      }
    }
  },
  setProspectTags: (state, data) => {
    Vue.set(state, "prospectTags", data.prospect_tags);
    Vue.set(state, "totalProspectTags", data.total_count);
  },
  addProspectTag: (state, data) => {
    Vue.set(state, "prospectTags", [data, ...state.prospectTags]);
    Vue.set(state, "totalProspectTags", state.totalProspectTags + 1);
  },
  removeProspectTag: (state, data) => {
    const arr = state.prospectTags.filter(
      i => Number(i.id) !== Number(data.id)
    );
    Vue.set(state, "prospectTags", arr);
    Vue.set(state, "totalProspectTags", state.totalProspectTags - 1);
  }
};

export const TagsActions = {
  getBranches: ({ state, commit, dispatch }, data = {}) => {
    if (!state.currentCenter.enable_branch) {
      commit("setBranches", { branches: [], total_count: 0 });
      return { success: false, data: [] };
    }
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/branches${params}`)
      .then(response => {
        commit("setBranches", response.data);
        return { success: true, data: response.data.branches };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch branches from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: [] };
      });
  },
  createBranch: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/branches", { branch: data.branch })
      .then(response => {
        commit("addBranch", response.data);
        const title = `New branch added`;
        const message = `Success! New branch has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create branch.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateBranch: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/branches/${data.id}`, { branch: data.branch })
      .then(response => {
        commit("setBranch", response.data);
        const title = `Branch updated`;
        const message = `Success! The branch has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update branch.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteBranch: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/branches/${data.id}`)
      .then(response => {
        commit("removeBranch", data);
        const title = `Branch deleted`;
        const message = `Success! The branch has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete branch.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  getLabels: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/labels${params}`)
      .then(response => {
        commit("setLabels", response.data);
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch tags from server.";
        dispatch("showToast", { message, type: "error" });
      });
  },
  createLabel: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/labels", { label: data.label })
      .then(response => {
        commit("addLabel", response.data);
        const title = `New tag added`;
        const message = `Success! New tag has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateLabel: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/labels/${data.id}`, { label: data.label })
      .then(response => {
        commit("setLabel", response.data);
        const title = `Tag updated`;
        const message = `Success! The tag has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteLabel: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/labels/${data.id}`)
      .then(response => {
        commit("removeLabel", data);
        const title = `Tag deleted`;
        const message = `Success! The tag has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  },
  //
  getProspectTags: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/prospect_tags${params}`)
      .then(response => {
        commit("setProspectTags", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch prospect tags from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createProspectTag: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/prospect_tags", { prospect_tag: data.prospect_tag })
      .then(response => {
        commit("addProspectTag", response.data);
        const title = `New prospect tag added`;
        const message = `Success! New prospect tag has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create prospect tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateProspectTag: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/prospect_tags/${data.id}`, {
        prospect_tag: data.prospect_tag
      })
      .then(response => {
        commit("setProspectTag", response.data);
        const title = `Prospect tag updated`;
        const message = `Success! The prospect tag has been updated.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update prospect tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteProspectTag: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/prospect_tags/${data.id}`)
      .then(response => {
        commit("removeProspectTag", data);
        const title = `Prospect tag deleted`;
        const message = `Success! The prospect tag has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete prospect tag.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/tags.store.js